module.exports = __webpack_public_path__ + "img/11.5bec7cf4.jpg";